<template>
  <Modal :title="title" width="500" v-model="isShow" :mask-closable="false">
    <div class="down__info">
      <div class="one" v-if="this.process_state === 0">
        <div>请点击保存导出数据！</div>
      </div>
      <p
        v-if="this.process_state === 1 || this.process_state === 2"
        class="file_name"
      >
        导出全部数据
      </p>
      <span style="margin: 8px 0 0 40px" v-if="this.process_state === 2">
        <span style="margin: 0 62px 0 10px">{{ title }}</span>
        <Icon class="icon" color="#3CCBA6" type="ios-checkmark" size="14" />
        <a
          :href="(isDev ? '/dev' : '') + this.derive + '?type=' + this.types"
          class="down"
          @click="report()"
        >
          下载
        </a>
      </span>
    </div>
    <div class="stauts" v-if="this.process_state === 1">
      <Progress :percent="timeconnt" hide-info status="active" text-inside />
    </div>
    <div slot="footer">
      <Button type="text" @click="isShow = false">关闭</Button>
      <Button type="primary" @click="submit" :loading="loading">保存</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    types: Number,
    manufacture: String,
    derive: String,
    condition: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      isShow: this.value,
      loading: false,
      process_state: 0,
      timeconnt: 1,
      https: '',
    }
  },
  watch: {
    value(val) {
      this.isShow = val
    },
    isShow(val) {
      this.$emit('input', val)
    },
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
  },
  methods: {
    submit() {
      this.$Notice.open({
        title: '导出提示',
        desc: '预计导出时间1分钟，请等待...',
      })
      this.timeconnt = 1
      this.process_state = 1
      this.loading = true
      setTimeout(() => {
        this.timeconnt = 15
      }, 6000)
      setTimeout(() => {
        this.timeconnt = 50
      }, 15000)
      setTimeout(() => {
        this.timeconnt = 85
      }, 30000)
      setTimeout(() => {
        this.timeconnt = 100
        this.process_state = 2
      }, 45000)
      this.$http
        .post(this.manufacture, {
          type: this.types,
          ...this.condition,
        })
        .then(({ success, data }) => {
          if (success) {
          } else {
            this.process_state = 0
            this.timeconnt = 1
            this.loading = false
          }
        })
    },
    report() {
      this.loading = false
      this.isShow = false
      this.process_state = 0
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
.schedule-title {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}
.schedule-coordination {
  float: right;

  .schedule-coordination-name {
    display: inline-block;
    width: 60px;
  }
}
.spin-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  width: 100%;
  height: 100px;
  position: relative;
}
.file_name {
  font-size: 14px;
  margin: 0 0 5px 20px;
}
.stauts {
  margin: 0 40px 0 20px;
}
.one {
  font-size: 14px;
  margin: 10px 0 0 25px;
}
.down {
  margin: 0 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DeriveModle.vue